import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export type HiddenEyeIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const HiddenEyeIcon: React.FC<HiddenEyeIconProps> = ({
  title = 'HiddenEye',
  viewBox = '0 0 24 24',
  ...props
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    <path
      d="M3 3L21 21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.584 10.587C9.80248 11.3679 9.80203 12.6345 10.583 13.416C11.3639 14.1975 12.6305 14.1979 13.412 13.417"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.08797 4.4035C8.55698 4.5554 8.24967 5.10899 8.40157 5.63997C8.55346 6.17096 9.10705 6.47827 9.63803 6.32637L9.08797 4.4035ZM12 4.99994L11.9965 5.99994H12V4.99994ZM22 11.9999L22.8682 12.4962C23.0439 12.1888 23.0439 11.8113 22.8682 11.5038L22 11.9999ZM18.7626 14.8092C18.3878 15.2148 18.4127 15.8474 18.8182 16.2223C19.2238 16.5972 19.8565 16.5723 20.2314 16.1667L18.7626 14.8092ZM17.9162 18.178C18.374 17.8692 18.4949 17.2477 18.1861 16.7898C17.8773 16.3319 17.2557 16.2111 16.7979 16.5199L17.9162 18.178ZM2 11.9999L1.13182 11.5037C0.956079 11.8111 0.956057 12.1886 1.13177 12.4961L2 11.9999ZM7.19335 7.48652C7.65041 7.17649 7.7696 6.55465 7.45958 6.09759C7.14956 5.64053 6.52771 5.52133 6.07065 5.83136L7.19335 7.48652ZM9.63803 6.32637C10.4049 6.10701 11.1989 5.99711 11.9965 5.99993L12.0035 3.99994C11.0175 3.99645 10.036 4.13231 9.08797 4.4035L9.63803 6.32637ZM12 5.99994C15.52 5.99994 18.5732 8.01884 21.1318 12.4961L22.8682 11.5038C20.0928 6.64703 16.48 3.99994 12 3.99994V5.99994ZM21.1318 11.5037C20.3842 12.8115 19.5933 13.9105 18.7626 14.8092L20.2314 16.1667C21.1827 15.1374 22.0598 13.9103 22.8682 12.4962L21.1318 11.5037ZM16.7979 16.5199C15.3292 17.5104 13.7394 17.9999 12 17.9999V19.9999C14.1446 19.9999 16.1228 19.3875 17.9162 18.178L16.7979 16.5199ZM12 17.9999C8.48001 17.9999 5.4268 15.981 2.86823 11.5038L1.13177 12.4961C3.9072 17.3528 7.51999 19.9999 12 19.9999V17.9999ZM2.86818 12.4962C4.18518 10.1922 5.63485 8.54365 7.19335 7.48652L6.07065 5.83136C4.19115 7.10623 2.55282 9.01772 1.13182 11.5037L2.86818 12.4962Z"
      fill="currentColor"
    />
  </CreateIconComponent>
);

export default HiddenEyeIcon;
